import React, { useState } from 'react';
import { READING_LIST } from '../data';

const TYPE_STYLES = {
  Reading: { color: '#6366f1', label: 'Reading' },
  Thinking: { color: '#e8c547', label: 'Thinking' },
  Listening: { color: '#22c55e', label: 'Listening' },
};

export default function ReadingFeed() {
  const [hovered, setHovered] = useState(null);

  return (
    <section id="writing" style={{ padding: '120px 0', borderTop: '1px solid var(--section-border, rgba(26,26,26,0.06))' }}>
      <div style={{ padding: '0 12%' }}>
        <div className="fade-in" style={{ marginBottom: '64px' }}>
          {/* Prominent eyebrow — tells visitors exactly what this section is */}
          <div style={{ fontFamily: 'var(--font-mono)', fontSize: '11px', letterSpacing: '0.28em', color: 'var(--ink-mid)', textTransform: 'uppercase', marginBottom: '16px' }}>
            What I'm Reading & Thinking
          </div>
          <h2 style={{ fontFamily: 'var(--font-display)', fontSize: 'clamp(36px, 5vw, 64px)', fontWeight: 600, color: 'var(--ink)', lineHeight: 1, letterSpacing: '-0.03em', marginBottom: '12px' }}>
            The Notebook
          </h2>
          <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', color: 'var(--ink-light)', fontWeight: 300, maxWidth: '480px', lineHeight: 1.7 }}>
            A rolling public notebook — books shaping my thinking, ideas I'm working through, podcasts worth your time. Updated monthly.
          </p>
        </div>

        <div style={{ display: 'flex', flexDirection: 'column', gap: '0' }}>
          {READING_LIST.map((item, i) => {
            const typeStyle = TYPE_STYLES[item.type] || TYPE_STYLES.Thinking;
            return (
              <div
                key={i}
                onMouseEnter={() => setHovered(i)}
                onMouseLeave={() => setHovered(null)}
                style={{
                  padding: '28px 0', borderBottom: '1px solid rgba(26,26,26,0.07)',
                  display: 'grid', gridTemplateColumns: '120px 1fr',
                  gap: '32px', alignItems: 'start',
                  transition: 'background 0.2s',
                  background: hovered === i ? 'rgba(26,26,26,0.02)' : 'transparent',
                  cursor: 'default',
                  marginLeft: hovered === i ? '-12px' : '0',
                  paddingLeft: hovered === i ? '12px' : '0',
                }}
              >
                <div style={{ fontFamily: 'var(--font-mono)', fontSize: '9px', letterSpacing: '0.2em', color: typeStyle.color, textTransform: 'uppercase', paddingTop: '4px', display: 'flex', alignItems: 'center', gap: '8px' }}>
                  <span style={{ width: '5px', height: '5px', borderRadius: '50%', background: typeStyle.color, display: 'inline-block', flexShrink: 0 }} />
                  {typeStyle.label}
                </div>
                <div>
                  <div style={{ fontFamily: 'var(--font-display)', fontSize: '20px', fontWeight: 600, color: 'var(--ink)', marginBottom: '4px', letterSpacing: '-0.01em' }}>
                    {item.title}
                    {item.author && <span style={{ fontStyle: 'italic', fontWeight: 400, color: 'var(--ink-mid)', marginLeft: '10px', fontSize: '16px' }}>— {item.author}</span>}
                  </div>
                  <div style={{ fontFamily: 'var(--font-body)', fontSize: '13px', color: 'var(--ink-mid)', lineHeight: 1.7, fontWeight: 300 }}>{item.note}</div>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
